


















import { defineComponent } from '@vue/composition-api';
import { RightArrowOutline12 } from '@hb/coffee-icons';

// static component
// [功能说明]: 还款信息展示组件
interface Props {
  label?: string;
  value?: string;
}

export default defineComponent({
  name: 'RepaymentInfo',
  components: {
    RightArrowOutline12,
  },
  props: {
    label: {
      type: String,
      default: '怎么还',
    },
    value: {
      type: String,
      default: '12个月&nbsp;&nbsp;首期2月28日&nbsp;应还866.34元',
    },
  },
  emits: ['click'],
  setup(props: Props, { emit }) {
    // 处理点击事件
    const handleClick = () => {
      emit('click');
    };

    return {
      handleClick,
    };
  },
});
